<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2026-06-22 15:32:38
 * @LastEditors: hl
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/detail/logistics/index.vue
-->
<template>
  <!-- 订单详情物流 -->
  <div class="detail_log">
    <title-bar-back :title="'订单追踪'" @back="back">
      <div class="left font12 icon_list">
        <!-- 客服 -->
        <pharmacist />
      </div>
    </title-bar-back>

    <div v-if="this.$route.query.purPage !== 'milkplan'">
      <!-- 包裹切换 -->
      <switch-bar :list="list" v-model="chooseIndex" />

      <!-- 订单状态信息 -->
      <order-status-det
        :statusConstant="statusConstant"
        :subOrderStatusTitle="subOrderStatusTitle"
      />

      <!-- 包裹内商品列表 -->
      <div
        v-if="
          currentLogisticModel &&
            currentLogisticModel.parcelDetailList &&
            currentLogisticModel.parcelDetailList.length
        "
        class="goods_con"
      >
        <div
          v-for="(goods, index) in currentLogisticModel.parcelDetailList"
          :key="index"
          class="goods_item"
        >
          <img :src="goods.skuPic" alt="" class="goods_img" />
          <div class="goods_right">
            <div class="goods_name font12 colo055 text_left">
              {{ goods.skuName }}
            </div>
            <div class="goods_bottom">
              <span v-if="goods.skuSpec" class="font10 colo055"
                >规格: {{ goods.skuSpec }}</span
              >
              <span v-else></span>
              <span class="font10 colo055">× {{ goods.skuAmount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 物流轨迹详情 -->
    <div
      v-if="
        currentLogisticModel &&
          currentLogisticModel.trackings &&
          currentLogisticModel.trackings.length > 1
      "
      class="has_tab_container"
    >
      <div class="logistic_tab">
        <div
          v-for="(item, index) in currentLogisticModel.trackings"
          :key="index"
          :class="{ active_tab: selectLogisticIndex === index }"
          class="logistic_tab_item font12"
          @click="selectLogisticIndex = index"
        >
          物流{{ index + 1 }}
        </div>
      </div>
      <log-list :trackBean="trackBean" />
    </div>
    <div v-else>
      <log-list :trackBean="trackBean" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const Pharmacist = () =>
  import("@/components/Pharmacist").then(m => m.default || m);
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import LogList from "./components/LogList";
import SwitchBar from "./components/SwitchBar";
import OrderStatusDet from "./components/OrderStatusDet";

export default {
  name: "Logistics",
  components: {
    TitleBarBack,
    LogList,
    SwitchBar,
    OrderStatusDet,
    Pharmacist
  },
  data() {
    return {
      chooseIndex: 0,
      selectLogisticIndex: 0
    };
  },
  watch: {
    chooseIndex() {
      this.selectLogisticIndex = 0;
    }
  },
  created() {
    if (this.$route.query.purPage == "milkplan") {
      this.getMlikPlanTrackData();
    } else {
      this.getData();
      this.getTrackData();
    }
  },
  computed: {
    ...mapGetters([
      "getUserOrder",
      "getTrackingDataByOrderSn",
      "getTrackingDataByTrackingNo"
    ]),
    list() {
      return this.getTrackingDataByOrderSn || [];
    },
    currentLogisticModel() {
      if (this.list.length === 0) return null;
      return this.list[this.chooseIndex] || null;
    },
    statusConstant() {
      return this.currentLogisticModel
        ? this.currentLogisticModel.statusConstant
        : "";
    },
    subOrderStatusTitle() {
      if (!this.currentLogisticModel) return "";
      return this.getOrderStatusTitle(this.currentLogisticModel.orderStatus);
    },
    trackBean() {
      if (this.$route.query.purPage == "milkplan") {
        return this.getTrackingDataByTrackingNo;
      }
      if (!this.currentLogisticModel || !this.currentLogisticModel.trackings)
        return null;
      return (
        this.currentLogisticModel.trackings[this.selectLogisticIndex] || null
      );
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    // 获取详情数据
    getData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      this.$store
        .dispatch("order/getUserOrder", { params })
        .then(() => {})
        .catch(() => {});
    },
    // 小b查看全部包裹物流信息
    getTrackData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      this.$store
        .dispatch("order/getTrackingDataByOrderSn", { params })
        .then(() => {
          this.initChooseIndex();
        })
        .catch(() => {});
    },
    getMlikPlanTrackData() {
      const params = {
        trackingNo: this.$route.query.trackingNo
      };
      this.$store
        .dispatch("order/getTrackingDataByTrackingNo", { params })
        .then(() => {})
        .catch(() => {});
    },
    // 根据 subOrderSn 默认选择匹配的包裹
    initChooseIndex() {
      const subOrderSn = this.$route.query.subOrderSn;
      if (!subOrderSn) {
        this.chooseIndex = 0;
        return;
      }
      const idx = this.list.findIndex(item => item.subOrderSn === subOrderSn);
      if (idx !== -1) {
        this.chooseIndex = idx;
      } else {
        this.chooseIndex = 0;
      }
    },
    getOrderStatusTitle(status) {
      switch (status) {
        case 5:
          return "待审核";
        case 10:
          return "待付款";
        case 11:
          return "待发货";
        case 12:
          return "待收货";
        case 13:
        case 14:
          return "已完成";
        case -10:
        case -11:
          return "订单关闭";
        case -5:
          return "审核失败";
        case -9:
          return "退款中";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.detail_log {
  background: #f6f7f8;
  min-height: 100vh;
  padding-bottom: 24px;
  box-sizing: border-box;
  .icon_list {
    padding-left: 4px;
    .left_icon {
      display: block;
      width: 24px;
    }
  }
  .goods_con {
    background: #fff;
    padding: 12px;
    margin-top: 12px;

    .goods_item {
      display: flex;
      align-items: center;
      height: 80px;
      box-sizing: border-box;
      padding: 12px 0;
      border-bottom: 1px solid #f6f7f8;
      &:last-child {
        border-bottom: none;
      }
      .goods_img {
        width: 56px;
        height: 56px;
        border-radius: 4px;
        flex-shrink: 0;
      }
      .goods_right {
        flex: 1;
        height: 56px;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .goods_name {
          line-height: 16px;
          height: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .goods_bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 14px;
        }
      }
    }
  }
  .has_tab_container {
    margin: 12px 12px 0 12px;
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    .logistic_tab {
      display: flex;
      background: #fff;
      height: 42px;
      align-items: center;
      padding: 12px 16px 0;
      overflow-x: auto;
      white-space: nowrap;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f7f8;
      &::-webkit-scrollbar {
        display: none;
      }
      .logistic_tab_item {
        padding: 0 16px 8px;
        color: #555;
        position: relative;
        cursor: pointer;
        &.active_tab {
          color: #bf9264;
          font-weight: 500;
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 20px;
            height: 2px;
            background: #bf9264;
            border-radius: 1px;
          }
        }
      }
    }
    ::v-deep .log_con {
      margin: 0;
      border-radius: 0;
      margin-top: 0;
    }
  }
}
</style>
